import React from 'react';

import Programming from 'components/Tvendo/Distribution/Operations/Programming/List';

export default function () {
  return <Programming />;
}